import { ApplicationEntity } from './applications'
import { RecordStatus } from './base'

export enum JobCategory {
  ASSEMBLER = 'ASSEMBLER',
  CHERRY_PICKER_OPERATOR = 'CHERRY_PICKER_OPERATOR',
  EVENT_STAFF = 'EVENT_STAFF',
  FORKLIFT_OPERATOR = 'FORKLIFT_OPERATOR',
  FULFILLMENT_ASSOCIATE = 'FULFILLMENT_ASSOCIATE',
  GENERAL_LABORER = 'GENERAL_LABORER',
  GRADER = 'GRADER',
  MATERIAL_HANDLER = 'MATERIAL_HANDLER',
  PACKER = 'PACKER',
  PICKER = 'PICKER',
  PRODUCTION_ASSOCIATE = 'PRODUCTION_ASSOCIATE',
  SANITATION_WORKER = 'SANITATION_WORKER',
  STAGEHAND = 'STAGEHAND',
  STANDUP_FORKLIFT_OPERATOR = 'STANDUP_FORKLIFT_OPERATOR',
  UNLOADER = 'UNLOADER',
  WAREHOUSE_ASSOCIATE = 'WAREHOUSE_ASSOCIATE',
  MACHINE_OPERATOR = 'MACHINE_OPERATOR',
  OTHER = 'OTHER',
}

export const JOB_CATEGORY_TO_STRING: Record<JobCategory, string> = {
  [JobCategory.ASSEMBLER]: 'Assembler',
  [JobCategory.CHERRY_PICKER_OPERATOR]: 'Cherry Picker Operator',
  [JobCategory.EVENT_STAFF]: 'Event Staff',
  [JobCategory.FORKLIFT_OPERATOR]: 'Forklift Operator',
  [JobCategory.FULFILLMENT_ASSOCIATE]: 'Fulfillment Associate',
  [JobCategory.GENERAL_LABORER]: 'General Laborer',
  [JobCategory.GRADER]: 'Grader',
  [JobCategory.MATERIAL_HANDLER]: 'Material Handler',
  [JobCategory.PACKER]: 'Packer',
  [JobCategory.PICKER]: 'Picker',
  [JobCategory.PRODUCTION_ASSOCIATE]: 'Production Associate',
  [JobCategory.SANITATION_WORKER]: 'Sanitation Worker',
  [JobCategory.STAGEHAND]: 'Stagehand',
  [JobCategory.STANDUP_FORKLIFT_OPERATOR]: 'Standup Forklift Operator',
  [JobCategory.UNLOADER]: 'Unloader',
  [JobCategory.WAREHOUSE_ASSOCIATE]: 'Warehouse Associate',
  [JobCategory.MACHINE_OPERATOR]: 'Machine Operator',
  [JobCategory.OTHER]: 'Other',
}

export enum JobPostPayRangeCadence {
  HOURLY = 'HOURLY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
}

export enum PaymentFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  SEMIMONTHLY = 'SEMIMONTHLY',
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
}

export enum JobPostEmploymentType {
  CONTRACT = 'CONTRACT',
  PERMANENT = 'PERMANENT',
  TEMPORARY = 'TEMPORARY',
}

export const EMPLOYMENT_TYPE_TO_STRING: Record<JobPostEmploymentType, string> =
  {
    [JobPostEmploymentType.CONTRACT]: 'Contract',
    [JobPostEmploymentType.PERMANENT]: 'Permanent',
    [JobPostEmploymentType.TEMPORARY]: 'Temporary',
  }

export enum JobPostEmploymentCadenceType {
  PART_TIME = 'PART_TIME',
  FULL_TIME = 'FULL_TIME',
}

export const EMPLOYMENT_CADENCE_TYPE_TO_STRING: Record<
  JobPostEmploymentCadenceType,
  string
> = {
  [JobPostEmploymentCadenceType.PART_TIME]: 'Part-time',
  [JobPostEmploymentCadenceType.FULL_TIME]: 'Full-time',
}

export enum JobPostScheduleType {
  FOUR_HOUR_SHIFT = 'FOUR_HOUR_SHIFT',
  EIGHT_HOUR_SHIFT = 'EIGHT_HOUR_SHIFT',
  TEN_HOUR_SHIFT = 'TEN_HOUR_SHIFT',
  TWELVE_HOUR_SHIFT = 'TWELVE_HOUR_SHIFT',
  MORNING_SHIFT = 'MORNING_SHIFT',
  DAY_SHIFT = 'DAY_SHIFT',
  EVENING_SHIFT = 'EVENING_SHIFT',
  NIGHT_SHIFT = 'NIGHT_SHIFT',
  OVERNIGHT_SHIFT = 'OVERNIGHT_SHIFT',
  ROTATING_SHIFT = 'ROTATING_SHIFT',
  TWO_TWO_THREE = 'TWO_TWO_THREE',
  MONDAY_TO_FRIDAY = 'MONDAY_TO_FRIDAY',
  WEEKENDS_AS_NEEDED = 'WEEKENDS_AS_NEEDED',
  WEEKENDS_ONLY = 'WEEKENDS_ONLY',
  NO_WEEKENDS = 'NO_WEEKENDS',
  EVERY_WEEKEND = 'EVERY_WEEKEND',
  ROTATING_WEEKENDS = 'ROTATING_WEEKENDS',
}

export const SCHEDULE_TYPE_TO_STRING: Record<JobPostScheduleType, string> = {
  [JobPostScheduleType.FOUR_HOUR_SHIFT]: '4 hour shift',
  [JobPostScheduleType.EIGHT_HOUR_SHIFT]: '8 hour shift',
  [JobPostScheduleType.TEN_HOUR_SHIFT]: '10 hour shift',
  [JobPostScheduleType.TWELVE_HOUR_SHIFT]: '12 hour shift',
  [JobPostScheduleType.MORNING_SHIFT]: 'Morning shift',
  [JobPostScheduleType.DAY_SHIFT]: 'Day shift',
  [JobPostScheduleType.EVENING_SHIFT]: 'Evening shift',
  [JobPostScheduleType.NIGHT_SHIFT]: 'Night shift',
  [JobPostScheduleType.OVERNIGHT_SHIFT]: 'Overnight shift',
  [JobPostScheduleType.ROTATING_SHIFT]: 'Rotating shift',
  [JobPostScheduleType.TWO_TWO_THREE]: '2-2-3',
  [JobPostScheduleType.MONDAY_TO_FRIDAY]: 'Monday to Friday',
  [JobPostScheduleType.WEEKENDS_AS_NEEDED]: 'Weekends as needed',
  [JobPostScheduleType.WEEKENDS_ONLY]: 'Weekends only',
  [JobPostScheduleType.NO_WEEKENDS]: 'No weekends',
  [JobPostScheduleType.EVERY_WEEKEND]: 'Every weekend',
  [JobPostScheduleType.ROTATING_WEEKENDS]: 'Rotating weekends',
}

export const PAY_RANGE_CADENCE_TO_STRING: Record<
  JobPostPayRangeCadence,
  string
> = {
  [JobPostPayRangeCadence.HOURLY]: '/hr',
  [JobPostPayRangeCadence.DAILY]: '/day',
  [JobPostPayRangeCadence.WEEKLY]: '/week',
  [JobPostPayRangeCadence.MONTHLY]: '/month',
  [JobPostPayRangeCadence.ANNUALLY]: '/year',
}

export const PAY_RANGE_CADENCE_TO_LONG_STRING: Record<
  JobPostPayRangeCadence,
  string
> = {
  [JobPostPayRangeCadence.HOURLY]: 'Per hour',
  [JobPostPayRangeCadence.DAILY]: 'Per day',
  [JobPostPayRangeCadence.WEEKLY]: 'Per week',
  [JobPostPayRangeCadence.MONTHLY]: 'Per month',
  [JobPostPayRangeCadence.ANNUALLY]: 'Per year',
}

export const JOB_CATEGORY_TO_TRABA_JOB_BOARD_URL_PATH: Record<
  JobCategory,
  string
> = {
  [JobCategory.ASSEMBLER]: 'assembler',
  [JobCategory.CHERRY_PICKER_OPERATOR]: 'cherry-picker-operator',
  [JobCategory.EVENT_STAFF]: 'event-staff',
  [JobCategory.FORKLIFT_OPERATOR]: 'forklift-operator',
  [JobCategory.FULFILLMENT_ASSOCIATE]: 'fulfillment-associate',
  [JobCategory.GENERAL_LABORER]: 'general-laborer',
  [JobCategory.GRADER]: 'grader',
  [JobCategory.MATERIAL_HANDLER]: 'material-handler',
  [JobCategory.PACKER]: 'packer',
  [JobCategory.PICKER]: 'picker',
  [JobCategory.PRODUCTION_ASSOCIATE]: 'production-associate',
  [JobCategory.SANITATION_WORKER]: 'sanitation-worker',
  [JobCategory.STAGEHAND]: 'stagehand',
  [JobCategory.STANDUP_FORKLIFT_OPERATOR]: 'standup-forklift-operator',
  [JobCategory.UNLOADER]: 'unloader',
  [JobCategory.WAREHOUSE_ASSOCIATE]: 'warehouse-associate',
  [JobCategory.MACHINE_OPERATOR]: 'machine-operator',
  [JobCategory.OTHER]: 'general-application',
}

export type JobPostInfo = {
  id: string
  createdAt: Date
  updatedAt: Date
  recordStatus: RecordStatus
  // General info for the job post
  title: string
  description: string
  titleEs?: string
  descriptionEs?: string
  jobCategory: JobCategory
  jobCategoryOtherInfo: string | null
  employmentType?: JobPostEmploymentType | null
  employmentCadence?: JobPostEmploymentCadenceType | null
  applicationEntityId: string | null
  // Salary info
  payRangeStart: number | null
  payRangeEnd: number | null
  payRangeCadence: JobPostPayRangeCadence
  paymentFrequency: PaymentFrequency
  payRangeText: string | null
  scheduleTypes: JobPostScheduleType[]
}

export enum ExternalJobPostStatus {
  PUBLISHED = 'PUBLISHED',
  UNPUBLISHED = 'UNPUBLISHED',
}

export type IndeedJobPostInfo = {
  id: string
  createdAt: Date
  updatedAt: Date
  jobPost: JobPostInfo
  indeedJobPostToLocations: IndeedJobPostToJobLocation[]
}

export type TrabaJobBoardJobPostInfo = {
  id: string
  createdAt: Date
  updatedAt: Date
  jobPost: JobPostInfo
  trabaJobBoardJobPostToLocations: TrabaJobBoardJobPostToJobLocation[]
}

export type IndeedJobPostToJobLocation = {
  id: string
  createdAt: Date
  updatedAt: Date
  jobPostStatus: ExternalJobPostStatus
  language: SupportedLanguageTag
  indeedJobPostInfoId: string
  indeedJobPostInfo: IndeedJobPostInfo
  jobLocationId: string
  jobLocation: JobLocation
  applicantCount?: number
  applicantCountLast24h?: number
  updatedBy?: string

  indeedSponsorshipType?: IndeedSponsorshipType
  indeedSponsorshipDetails?: IndeedSponsorshipDetailsResponse[]
  indeedSponsorshipStats?: IndeedSponsorshipStats
}

export type TrabaJobBoardJobPostToJobLocation = {
  id: string
  createdAt: Date
  updatedAt: Date
  jobPostStatus: ExternalJobPostStatus
  language: SupportedLanguageTag
  trabaJobBoardJobPostInfoId: string
  trabaJobBoardJobPostInfo: TrabaJobBoardJobPostInfo
  jobLocationId: string
  jobLocation: JobLocation
  applicantCount?: number
  applicantCountLast24h?: number
  updatedBy?: string
}

export type JobLocationBase = {
  id: string
  createdAt: Date
  updatedAt: Date
  city: string
  state: string
  postalCode: string
  regionId?: string
}

export type JobLocation = JobLocationBase & {
  indeedInfo?: IndeedJobPostToJobLocation
  trabaJobBoardInfo?: TrabaJobBoardJobPostToJobLocation
}

export type IndeedSponsorshipDetailsResponse = {
  id: string
  createdAt: Date
  updatedAt: Date
  dailyAmountInDollars: number
  startDate: Date
  endDate: Date
  updatedBy: string
  indeedJobPostToJobLocationId: string
}

export type IndeedSponsorshipStats = {
  totalAmountSpentInDollars: number
  expectedTotalSpend: number
  latestEndDate: Date
}

export type IndeedSponsorshipDetailsRequest = {
  endDate: Date
  startDate?: Date
  dailyAmountInDollars: number
}

export type CreateJobLocationRequest = {
  city: string
  state: string
  postalCode: string
  regionId?: string

  // indicate which external job boards to post to
  indeedEnabled: boolean
  trabaJobBoardEnabled: boolean

  // language for the traba job board post at this location
  language?: SupportedLanguageTag

  indeedSponsorshipType?: IndeedSponsorshipType
  indeedSponsorshipDetails?: IndeedSponsorshipDetailsRequest
}

export enum SponsorshipUpdateScenario {
  EXTEND_BEFORE_END_DATE = 'EXTEND_BEFORE_END_DATE',
  EXTEND_AFTER_END_DATE = 'EXTEND_AFTER_END_DATE',
  INCREASE_AMOUNT = 'INCREASE_AMOUNT',
  DECREASE_AMOUNT = 'DECREASE_AMOUNT',
  STOP_TODAY = 'STOP_TODAY',
  UNPUBLISH_TODAY = 'UNPUBLISH_TODAY',
  SWITCH_TO_FREE = 'SWITCH_TO_FREE',
  // Combined scenarios
  EXTEND_AND_INCREASE = 'EXTEND_AND_INCREASE',
  EXTEND_AND_DECREASE = 'EXTEND_AND_DECREASE',
}

export type UpdateSponsorshipDetailsRequest =
  IndeedSponsorshipDetailsRequest & {
    unpublish?: boolean
    switchToFree?: boolean
  }

export type SponsorshipUpdatePreviewResponse = {
  scenario: SponsorshipUpdateScenario
  todayIncluded: boolean
  affectedDaysCount: number
  changesSummary: string
  warnings?: string[]
}

export type BatchUpdateSponsorshipDetailsRequest = {
  updates: BatchSponsorshipUpdateItem[]
}

export type BatchSponsorshipUpdateItem = {
  indeedJobPostToJobLocationId: string
  updateRequest: UpdateSponsorshipDetailsRequest
}

export type CreateIndeedJobPostInfoRequest = {
  // Class will be extended as needed with specific fields
}

export type CreateTrabaJobBoardJobPostInfoRequest = {
  // Class will be extended as needed with specific fields
}

export type CreateJobPostRequest = {
  title: string
  description: string // note: converted to markdown
  titleEs?: string
  descriptionEs?: string
  jobCategory: JobCategory
  jobCategoryOtherInfo?: string | null
  employmentType: JobPostEmploymentType
  employmentCadence: JobPostEmploymentCadenceType
  scheduleTypes: JobPostScheduleType[]

  // salary info
  payRangeStart: number
  payRangeEnd?: number
  payRangeCadence: JobPostPayRangeCadence
  paymentFrequency: PaymentFrequency

  // application entity
  shiftRequestId?: string
  roleId?: string

  // external job boards
  indeedInfo?: CreateIndeedJobPostInfoRequest
  trabaJobBoardInfo?: CreateTrabaJobBoardJobPostInfoRequest

  // job locations
  jobLocations?: CreateJobLocationRequest[]
}

export type UpdateJobPostInfoRequest = {
  jobPostId: string
  title?: string
  description?: string // note: converted to markdown
  titleEs?: string | null
  descriptionEs?: string | null
  jobCategory?: JobCategory
  jobCategoryOtherInfo?: string | null
  employmentType?: JobPostEmploymentType
  employmentCadence?: JobPostEmploymentCadenceType

  // salary info
  payRangeStart?: number
  payRangeEnd?: number | null
  payRangeCadence?: JobPostPayRangeCadence
  paymentFrequency?: PaymentFrequency
}

export type BulkUpsertJobLocationsRequest = {
  jobLocations: CreateJobLocationRequest[]
  jobPostId: string
}

export type JobPostResponse = {
  jobPostId: string
  jobPostInfo: JobPostInfo
  indeedInfo?: IndeedJobPostInfo
  trabaJobBoardInfo?: TrabaJobBoardJobPostInfo
  applicationEntity?: ApplicationEntity
  jobLocations: JobLocation[]
}

export enum JobPostSponsoredStatus {
  SPONSORED = 'SPONSORED',
  FREE = 'FREE',
  REMOVED = 'REMOVED',
}

export enum IndeedSponsorshipType {
  SPONSORED = 'SPONSORED',
  ORGANIC = 'ORGANIC',
}

export enum JobPostSource {
  INDEED = 'INDEED',
  TRABA_JOB_BOARD = 'TRABA_JOB_BOARD',
}

export enum SupportedLanguageTag {
  EN_US = 'EN_US',
  ES_US = 'ES_US',
}

export const LANGUAGE_LABELS: Record<SupportedLanguageTag, string> = {
  [SupportedLanguageTag.EN_US]: 'English',
  [SupportedLanguageTag.ES_US]: 'Español',
}
